import { Center } from '@chakra-ui/react'
import { lazy } from 'react'
import { Translation } from 'react-i18next'
import { Navigate, Route } from 'react-router-dom'

import MapIcon from '@/ui/assets/MapIcon'
import { backofficeRouteNames } from '@/ui/routes/routesNames/backofficeRouteNames'

const InternalLayout = lazy(() => import('@ui/layouts/InternalLayout'))
const Profile = lazy(() => import('@/therapist/pages/profile'))

export default function BackofficeRoutes() {
  return (
    <>
      <Route
        path={backofficeRouteNames.home}
        element={
          <Navigate to={backofficeRouteNames.dashboard} replace={true} />
        }
      />
      <Route
        element={
          <Translation>
            {(t) => (
              <InternalLayout
                homeLink={backofficeRouteNames.home}
                menuItems={[
                  {
                    name: t('internalLayout.general.home'),
                    icon: <MapIcon />,
                    navigateTo: backofficeRouteNames.dashboard
                  }
                ]}
                searchItems={[]}
              />
            )}
          </Translation>
        }
      >
        <Route
          path={backofficeRouteNames.dashboard}
          element={<Center h={'full'}>Dashboard</Center>}
        />
        <Route path={backofficeRouteNames.profile} element={<Profile />} />
      </Route>
    </>
  )
}
